import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { transformBrandModelToUI } from 'src/components/enterprise/features/Corporate/components/Form/BrandOptions/brandOptions.utils';
import { CorpSubscriptionFundingType } from 'src/types/Corp';
import {
  ReportingOption,
  CorpInvoicingMethod,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

export type UseInvoicingMethodReturnType = {
  singleOptionSelected: boolean;
  disabledMultiOption: boolean;
  multiDisableReason: string;
};

export function useInvoicingMethodWrapper(): UseInvoicingMethodReturnType {
  const { setValue } = useFormContext();
  const { reporting, ghPlusEnabled, ghPlusSubscription, brand } = useWatch({
    name: ['reporting', 'ghPlusEnabled', 'ghPlusSubscription', 'brand'],
  });

  useEffect(() => {
    if (reporting === ReportingOption.NONE_REPORTING_OPTION) {
      setValue('invoicingMethod', CorpInvoicingMethod.SINGLE_OPTION);
    }
  }, [reporting, setValue]);

  const disabledMultiOption =
    ghPlusEnabled &&
    ghPlusSubscription?.funding === CorpSubscriptionFundingType.CORP;

  return {
    singleOptionSelected: reporting === ReportingOption.NONE_REPORTING_OPTION,
    disabledMultiOption,
    multiDisableReason:
      disabledMultiOption &&
      `Multiple invoices are not allowed when clients are invoiced for ${transformBrandModelToUI(
        brand
      )}`,
  };
}
